export default __webpack_public_path__ + "static/media/stage2_documents_2.9f65b7ed.png";